import { render, staticRenderFns } from "./MexIndex.vue?vue&type=template&id=4c78f3ec"
import script from "./MexIndex.vue?vue&type=script&lang=js"
export * from "./MexIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports